'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import { useRouter } from 'next/navigation'
import { useAuthState } from 'react-firebase-hooks/auth'
import { Error, NavHeader, RequestMiddlewareWrapper } from '@/components'
import { FirebaseServiceProviders } from '@/lib/firebase/FirebaseServiceProviders'
import { useClientTranslation } from './i18n/client'
import { ClientTranslationProvider } from './i18n/client/context'
import { defaultLanguage } from './i18n/config'

const queryClient = new QueryClient()

export default function RootNotFound() {
  const router = useRouter()
  const [user, _loading] = useAuthState(getAuth())
  const { t } = useClientTranslation(['common'])

  const handleReturnHome = () => {
    router.replace('/')
  }
  const showHoverMenu = !!user

  return (
    <FirebaseServiceProviders>
      <ClientTranslationProvider lang={defaultLanguage}>
        <RequestMiddlewareWrapper>
          <QueryClientProvider client={queryClient}>
            <NavHeader showHoverMenu={showHoverMenu} />
            <Error
              errorCode={404}
              onReturnHome={handleReturnHome}
              returnToHomeButtonText={t('buttons.returnToHome')}
            />
          </QueryClientProvider>
        </RequestMiddlewareWrapper>
      </ClientTranslationProvider>
    </FirebaseServiceProviders>
  )
}
